<template>
  <div class="successResult">
    <div class="topPayInfo">
      <img src="../../assets/mobile/payment_success_move.png" alt />
      <p class="successText">{{ $t("common.successText") }}</p>
      <p class="totalfeeBox">
        <span class="currency">{{ goodInfo.currencySymbol }}</span>
        <span class="totalfee">{{ goodInfo.totalFee }}</span>
      </p>
    </div>
    <div class="goodsBox">
      <div class="title">{{ $t("common.goodName") }}</div>
      <div class="goodName">{{ goodInfo.goodsName }}</div>
      <div class="title">{{ $t("common.goodDes") }}</div>
      <div class="goodDes">{{ goodInfo.goodsDetail }}</div>
    </div>
  </div>
</template>
<script>
import "@/style/moblie/reset.css";
export default {
  name: "successResult",
  data() {
    return {
      goodInfo: {
        currencySymbol: "",
        totalFee: "",
        goodsDetail: "",
        goodsName: ""
      }
    };
  },
  methods: {
    init() {
      let param = this.$route.query;
      this.goodInfo = {
        ...param
      };
    }
  },
  mounted() {
    this.init();
  }
};
</script>
<style lang="less">
.successResult {
  width: 100%;
  height: 100%;
  background: #fff;
  .topPayInfo {
    text-align: center;
    font-size: 0.36rem;
    padding-top: 1.4rem;
    img {
      display: block;
      width: 1.6rem;
      height: 1.6rem;
      margin: 0 auto 0.2rem;
    }
    .successText {
      margin-bottom: 0.3rem;
      font-weight: 600;
    }
    .totalfeeBox {
      color: rgba(255, 121, 40, 1);
      font-weight: 600;
    }
  }
  .goodsBox {
    width: 6.1rem;
    background: rgba(248, 248, 248, 1);
    border-radius: 0.12rem;
    margin: 0.8rem auto 0;
    padding: 0.3rem;
    .title {
      font-size: 0.28rem;
      color: rgba(153, 153, 153, 1);
      margin-bottom: 0.2rem;
    }
    .goodName,
    .goodDes {
      font-size: 0.32rem;
      color: rgba(51, 51, 51, 1);
      line-height: 0.42rem;
    }
    .goodName {
      margin-bottom: 0.4rem;
    }
  }
}
</style>
